import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
// import laptopImg from "../../Assets/about.png";
import laptopImg from "../../Assets/work_dp.jpeg";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={10}
            style={{
              justifyContent: "center",
              paddingTop: "20px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              About me <strong className="purple"></strong>
            </h1>
            <div className="about-img about-portrait">
              <img src={laptopImg} alt="about" className="img-fluid" />
            </div>
            <Aboutcard />
          </Col>
        </Row>

        <h1 className="project-heading">Education</h1>
        <p style={{ color: "var(--text-primary)", maxWidth: "900px", margin: "0 auto 2rem" }}>
          Masters in Computer Science, UMass Amherst — <strong>May 2026</strong>.
          <br />
          Coursework: Reinforcement Learning, Natural Language Processing, Distributed Systems,
          Modern Computer Architecture, Algorithms, Fairness &amp; Game Theory (Mechanism &amp; Auction Design,
          Stable Matching), Probabilistic Graphical Models, Responsible AI. 
        </p>

        <h1 className="project-heading">Recent Experience</h1>
        <div style={{ color: "var(--text-primary)", maxWidth: "900px", margin: "0 auto 2rem" }}>
          <ul>
            <li>
              <strong>Research Extern, Allen Institute for AI (AI2):</strong> literature-grounding for
              automated scientific discovery systems (evidence retrieval + multi-agent hypothesis and
              experiment selection).
            </li>
            <li>
              <strong>Graduate Student Researcher, UMass Amherst:</strong> sycophancy mitigation,
              robustness in RAG, and AI red-teaming contributions (PyRIT).
            </li>
            
          </ul>
        </div>

        <h1 className="project-heading">Core Skills</h1>
        <p style={{ color: "var(--text-primary)", maxWidth: "900px", margin: "0 auto 2rem" }}>
          Fine-tuning (PEFT/LoRA), RAG, agentic workflows (LangChain), evals, RL/RLHF;
          PyTorch, Distributed Inference, vLLM/DeepSpeed; SQL, BigQuery, GCP, AWS, Docker, Kubernetes.
        </p>

        <h1 className="project-heading">
          I'm stack-agnostic, but have the most experience with
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use & recommend
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
